import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, output, signal } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { formatCharacterCount } from '../input.helpers';
import { TextInputConfig } from '../input.type';

/**
 * Text input component.
 * @param maxLength - The maximum length of the text.
 * @param minLength - The minimum length of the text.
 * @param pattern - The pattern of the text.
 */
@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: BaseInputComponent, useExisting: TextInputComponent }]
})
export class TextInputComponent extends BaseInputComponent<string> implements OnInit, OnChanges {
    @Input() maxLength: TextInputConfig['maxLength'] = 255;
    @Input() minLength: TextInputConfig['minLength'];
    @Input() pattern: TextInputConfig['pattern'];
    @Input() password: TextInputConfig['password'] = false;
    @Input() passwordConditions: TextInputConfig['passwordConditions'] = false;
    @Input() route: string | string[] | any[];

    clickedLink = output<string | string[] | any[]>();

    characterCount: string;
    showPassword = signal(false);

    ngOnInit(): void {
        this.clearValue(this.value());
        this.characterCount = formatCharacterCount(this.maxLength, this.value());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) this.clearValue(changes.value.currentValue);
    }

    override onValueChange(value: string): void {
        super.onValueChange(value);
        this.characterCount = formatCharacterCount(this.maxLength, value);
    }

    onKeyPress(event: KeyboardEvent) {
        if (!this.pattern) return;
        if (!new RegExp(this.pattern).test(event.key)) event.preventDefault();
    }

    // This is to avoid displaying 'undefined' when the value passed in is undefined eg.: model.username, where username is undefined.
    clearValue(value: string) {
        if (!value) this.value.set(null);
    }

    togglePasswordVisibility() {
        this.showPassword.set(!this.showPassword());
    }
}
